import React, { useState } from 'react'
import { Section } from 'newComponents'
import './styles.scss'

const EolTable = (props) => {
  const { data } = props
  const { primary, items } = data
  const { table_title: title } = primary

  const [activeSdks, setActiveSdks] = useState([])

  const handleClick = (event, sdk) => {
    event.preventDefault()
    const openIndex = activeSdks.indexOf(sdk)
    const isInArray = openIndex !== -1

    if (isInArray) {
      const clonedArr = [...activeSdks]
      clonedArr.splice(openIndex, 1)
      setActiveSdks(clonedArr)
    } else {
      const clonedArr = [...activeSdks]
      clonedArr.push(sdk)
      setActiveSdks(clonedArr)
    }
  }

  const sdkList = []
  items.forEach((item) => {
    const { sdk } = item
    if (!sdkList.includes(sdk)) sdkList.push(sdk)
  })

  const noSdkVariant = !items[0]?.sdk
  const olderSdks = [
    '.NET',
    'Android',
    'Go',
    'iOS',
    'Java',
    'JavaScript',
    'Node.js (server-side)',
    'PHP',
    'Python',
    'React',
    'Ruby',
    'Relay Proxy'
  ]

  return (
    <Section className="end-of-life-table">
      <>
        {title?.html && (
          <div
            className="eol-table-title"
            dangerouslySetInnerHTML={{
              __html: title?.html
            }}
          />
        )}
      </>
      {sdkList.map((sdk) => {
        const isActive = activeSdks.includes(sdk) || noSdkVariant ? 'active' : ''
        const filteredRows = items.filter((item) => item.sdk === sdk)
        return (
          <div key={sdk} className="eol-table-container">
            {sdk && (
              <button
                className={`eol-table-header ${isActive}`}
                onClick={(event) => handleClick(event, sdk)}
                type="button"
              >
                <span className="eol-table-sdk">{sdk} SDK</span>
                <div className={`plus-minus ${isActive}`} />
              </button>
            )}
            <table className={`eol-table ${isActive}`}>
              <thead className="eol-table-head">
                <tr className="eol-table-row">
                  <th className="eol-table-heading eol-table-cell">{noSdkVariant ? 'API Version' : 'Version'}</th>
                  <th className="eol-table-heading eol-table-cell">Initial release date</th>
                  <th className="eol-table-heading eol-table-cell">EOL</th>
                </tr>
              </thead>
              <tbody className="eol-table-body">
                {filteredRows.map((row, index) => {
                  const { eol, release_date: date, version, sdk: rowSdk } = row
                  const isCurrent = index === 0 && (!eol || !sdk) ? 'Current' : ''
                  const orEarlier =
                    olderSdks.includes(rowSdk) && index === filteredRows.length - 1 ? `${eol} or earlier` : eol
                  const variousRelease = !date ? 'Various' : date
                  return (
                    <tr className="eol-table-row" key={`eol:${eol} release: ${date} version: ${version.text}`}>
                      {version?.text && <td className="eol-table-cell">{version.text}</td>}
                      <td className="eol-table-cell">{variousRelease}</td>
                      <td className="eol-table-cell">{isCurrent || orEarlier}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        )
      })}
    </Section>
  )
}

export default EolTable
